import { useLazyQuery } from "@apollo/client";
import "./info.scss";
import {
  // GET_LIQUIDITY_TVL,
  // GET_TRADE_VOLUME,
} from "../../state/graphql/gql";
import AreaChart from "../../components/AreaChart/AreaChart";
import { useCallback, useEffect, useState } from "react";
import BarChart from "../../components/BarChart/BarChart";
import Filter from "./Filter";
export default function Info() {


  return (
    <div className="info-main">
      <div className="title">Deri Overview</div>
      <div className="charts">
        {/* <div className="graph tvl">
          <AreaChart getData={getLiquidity} title="TVL" />
        </div>
        <div className="graph volume24">
          <Filter onChange={setVolumeDay} cycleArr={["7D", "30D"]} />
          <BarChart title="Volume 24H" getData={getTradeVolumeParam} />
        </div> */}
      </div>
      <div className="list-by-chain">
       
      </div>
    </div>
  );
}
